import { Plugin } from '@ckeditor/ckeditor5-core';
import { Widget } from '@ckeditor/ckeditor5-widget';
import { toWidget, toWidgetEditable } from '@ckeditor/ckeditor5-widget';
import InsertRawHtmlCommand from './raw-html-command';
export default class RawHtmlEditing extends Plugin {
    static get requires() {
        return [Widget];
    }
    init() {
        this._defineSchema();
        this._defineConverters();
        this.editor.commands.add('insertRawHtml', new InsertRawHtmlCommand(this.editor));
    }
    _defineSchema() {
        const schema = this.editor.model.schema;
        schema.register('rawHtml', {
            isObject: true,
            allowWhere: '$block',
        });
        schema.register('rawHtmlContent', {
            isLimit: true,
            allowIn: 'rawHtml',
            allowContentOf: '$block',
        });
    }
    _defineConverters() {
        const conversion = this.editor.conversion;
        // <rawHtml> converters
        conversion.for('upcast').elementToElement({
            model: 'rawHtml',
            view: 'x-raw-html',
        });
        conversion.for('dataDowncast').elementToElement({
            model: 'rawHtml',
            view: 'x-raw-html',
        });
        conversion.for('editingDowncast').elementToElement({
            model: 'rawHtml',
            view: (modelElement, { writer }) => {
                const div = writer.createContainerElement('div', {
                    class: 'raw-html',
                });
                return toWidget(div, writer, { label: 'raw html widget' });
            },
        });
        // <rawHtmlContent> converters
        conversion.for('upcast').elementToElement({
            model: 'rawHtmlContent',
            view: 'x-raw-html-content',
        });
        conversion.for('dataDowncast').elementToElement({
            model: 'rawHtmlContent',
            view: 'x-raw-html-content',
        });
        conversion.for('editingDowncast').elementToElement({
            model: 'rawHtmlContent',
            view: (modelElement, { writer }) => {
                const div = writer.createEditableElement('div', {
                    class: 'raw-html__content',
                });
                return toWidgetEditable(div, writer);
            },
        });
    }
}
